// LoadingSkeleton — shimmering placeholders while data loads.
// Per spec §18.6.

interface SkeletonGridProps {
  count?: number;
  variant?: 'design' | 'order' | 'reorder';
}

export function SkeletonGrid({ count = 6, variant = 'design' }: SkeletonGridProps) {
  return (
    <div className={`skel-grid skel-grid--${variant}`}>
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} variant={variant} />
      ))}
    </div>
  );
}

export function SkeletonCard({ variant }: { variant: 'design' | 'order' | 'reorder' }) {
  // Mirror DesignCard's actual structure so the loading state has the same
  // shape and rough size as the real cards (no jarring layout shift when
  // data arrives). Thumb is square (matches d-card__thumb 1:1), title +
  // meta + order line are stacked, then a two-button row for the design
  // variant or a single big button row for the reorder variant.
  if (variant === 'reorder') {
    return (
      <div className={`skel-card skel-card--${variant}`}>
        <div className="skel-card__thumb skeleton" />
        <div className="skel-card__body">
          <div className="skel-card__line skeleton" style={{ width: '70%' }} />
          <div className="skel-card__line skeleton" style={{ width: '55%' }} />
          <div className="skel-card__btn skeleton" style={{ height: '56px' }} />
        </div>
      </div>
    );
  }
  return (
    <div className={`skel-card skel-card--${variant}`}>
      <div className="skel-card__thumb skeleton" />
      <div className="skel-card__body">
        <div className="skel-card__line skeleton" style={{ width: '78%' }} />
        <div className="skel-card__line skeleton" style={{ width: '60%', height: '11px' }} />
        <div className="skel-card__line skeleton" style={{ width: '40%', height: '10px' }} />
        <div className="skel-card__btn-row">
          <div className="skel-card__btn skeleton" />
          <div className="skel-card__btn skeleton" />
        </div>
      </div>
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div className="skel-row">
      <div className="skel-row__thumb skeleton" />
      <div className="skel-row__body">
        <div className="skel-card__line skeleton" style={{ width: '40%' }} />
        <div className="skel-card__line skeleton" style={{ width: '60%' }} />
      </div>
      <div className="skel-row__pill skeleton" />
    </div>
  );
}
